/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Current Year Update */
(function () {
    const yearElement = document.getElementById('currentYear');
    if (yearElement) yearElement.textContent = new Date().getFullYear();
})();


/* All links in a new window */
document.querySelectorAll('a[href^="http"]').forEach(link => {
    if (link.hostname !== window.location.hostname) {
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
    }
});

/* Quote Spacing Fix */
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".gh-article blockquote:not(.kg-blockquote-alt)").forEach(blockquote => {
        let html = blockquote.innerHTML;

        // Check if there are at least two consecutive <br> tags
        if (html.match(/(<br\s*\/?>\s*){2,}/)) {
            // Replace double <br><br> with paragraph breaks
            html = html.replace(/(<br\s*\/?>\s*){2,}/g, '</p><p>');

            // Ensure content is wrapped in <p> if it's not already
            if (!blockquote.innerHTML.includes("<p>")) {
                html = `<p>${html}</p>`;
            }

            // Clean up redundant <br> at the start/end of blockquotes
            html = html.replace(/^<p><br\s*\/?>|<br\s*\/?><\/p>$/g, "");

            blockquote.innerHTML = html;
        }
    });
});

/* Author box linking */
document.addEventListener("DOMContentLoaded", function () {
    const section = document.querySelector(".gh-author p");

    if (section) {
        section.innerHTML = section.innerHTML
            .replace(/Stack Overflow/g, '<a href="https://stackoverflow.com" target="_blank" rel="noopener noreferrer">Stack Overflow</a>')
            .replace(/Discourse/g, '<a href="https://www.discourse.org" target="_blank" rel="noopener noreferrer">Discourse</a>');
    }
});

/* Remove the Stack Overflow Ads */
document.addEventListener('DOMContentLoaded', function() {
    const element = document.querySelector('.welovecodinghorror');
    if (element) {  // Add null check
        const tableParent = element.closest('.gh-table');
        if (tableParent) {
            tableParent.remove();
        }
    }
});

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');

    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
